import React, {Component, Fragment} from 'react';
import ReactJsonSchema from 'react-json-schema';

import Hotspot from './Hotspot';
import Tabs from './Tabs';
import Menu from './Menu';
import Button from './Button';
import Highlight from './Highlight';
import Tooltip from './Tooltip';
import Timer from './Timer';
import MiniTour from './MiniTour';
import Video from './Video';
import DragDrop from './DragDrop';


class ComponentRenderer extends  Component{

  constructor(props){
    super(props);

    let view = new ReactJsonSchema();
    view.setComponentMap({ Hotspot, Tabs, Menu, Button, Highlight, Tooltip, Timer, MiniTour, Video, DragDrop })

    this.state = {
      view: view
    }
  }

  static getDerivedStateFromProps(props, state) {

    let { components } = props;

    return {
      schema: components
    }
  }

  render(){
    let { schema, view } = this.state;

    return (
      <Fragment>
        {view.parseSchema(schema)}
      </Fragment>
    )
  }

}

export default ComponentRenderer



// WEBPACK FOOTER //
// ./src/components/ComponentRenderer.jsx